/**
 * @param {object} data
 * @param {object} requirements, this is requirement format:
 *  {
 *    [required_key_on_data]: string | {message: string, validation: Function},...
 *  }
 * @param {boolean} allowEmpty: if is false, only will check null and undefined.
 * otherwise will check "!"
 * @return {string[]} array with error messages.
 */
import get from "../lib/core/functional/get";

export function validateRequirements(data, requirements, allowEmpty = true) {
    const errors = [];
    Object.keys(requirements).forEach(requirement => {
        const value = data[requirement];
        const message = get('message')(requirements[requirement]) || requirements[requirement];
        const validation = get('validation')(requirements[requirement]) || defaultValidation(allowEmpty);
        if (!validation(value)) {
            errors.push(message);
        }
    });
    return errors;
}

const defaultValidation = allowEmpty => value =>
    !((allowEmpty && !value) || value === null || value === undefined);

export const isEmail = email => {
    // eslint-disable-next-line
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return email && re.test(String(email).toLowerCase());
};
